import React, { useState } from "react";
import PromptRouter from "./components/PromptRouter";
import Background from "./components/Background";
import ComponentsContainer from "./components/ComponentsContainer";

export default function App() {
  const [backgroundImage, setBackgroundImage] = useState(null);
  const [apiResult, setApiResult] = useState({});
  const [showCard, setShowCard] = useState(false);
  const [showCountdown, setShowCountdown] = useState(false);
  const [color, setColor] = useState("white");

  // Check if any components are visible
  const hasComponents = (apiResult && Object.keys(apiResult).length > 0) || showCard || showCountdown;

  // Function to handle background image updates from API responses
  const handleBackgroundUpdate = (imageUrl) => {
    if (imageUrl) {
      setBackgroundImage(imageUrl);
    }
  };

  // Function to handle API results from Agent component
  const handleApiResult = (result) => {
    setApiResult(result);
    
    // Update background image if provided in the response
    if (result && result.backgroundImage && handleBackgroundUpdate) {
      handleBackgroundUpdate(result.backgroundImage);
    }
  };

  // Function to handle local state changes from Agent component
  const handleLocalStateChange = (newShowCard, newShowCountdown, newColor) => {
    setShowCard(newShowCard);
    setShowCountdown(newShowCountdown);
    setColor(newColor);
  };

  return (
    <>
      <Background backgroundImage={backgroundImage} />
      <div className="agent-container">
        <PromptRouter 
          onBackgroundUpdate={handleBackgroundUpdate} 
          onApiResult={handleApiResult}
          onLocalStateChange={handleLocalStateChange}
          hasComponents={hasComponents}
        />
      </div>
      <div className="component-container">
        <ComponentsContainer 
          apiResult={apiResult} 
          showCard={showCard}
          showCountdown={showCountdown}
          color={color}
        />
      </div>
    </>
  );
}